import request from '@/shared/api/request';

export const deleteKubernetesPool = (kubernetes_uuid: string, pool_id: string): Promise<unknown> =>
  request({
    url: `/kubernetes/${kubernetes_uuid}/node_pools/${pool_id}/`,
    method: 'DELETE',
  });
